import styled from 'styled-components'

export const Modal = styled.div.attrs({ className: 'modal is-active' })``
export const ModalBackground = styled.div.attrs({ className: 'modal-background' })``
export const ModalCard = styled.div.attrs({ className: 'modal-card' })``
export const ModalCardHeader = styled.header.attrs({ className: 'modal-card-head' })``
export const ModalCardTitle = styled.p.attrs({ className: 'modal-card-title' })``
export const ModalCardBody = styled.section.attrs({ className: 'modal-card-body' })``
export const ModalCardFoot = styled.footer.attrs({ className: 'modal-card-foot' })``
